export default "__VITE_ASSET__4b697ba2__"